import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import FormGroup from '../helpers/FormGroup'

class CompanyMailing extends React.Component {
  constructor(props) {
    super(props)
  }

  validate() {
    //
  }

  render() {
    const values = this.props.data
    const setData = this.props.setData

    return(
      <fieldset className="fieldset">
        <legend className="h2 mb-2">Company Details</legend>
        <p className="mb-4">Add a mailing address here if different from your company address.</p>
        <div className="row">
          <div className="col-12">
            <FormGroup label="Mailing Address 1" value={values.mailing_address1} onChange={(v) => setData({mailing_address1: v})} />
          </div>
          <div className="col-12">
            <FormGroup label="Mailing Address 2" value={values.mailing_address2} onChange={(v) => setData({mailing_address2: v})} />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6">
            <FormGroup label="City" value={values.mailing_city} onChange={(v) => setData({mailing_city: v})} />
          </div>
          <div className="col-12 col-sm-6">
            <FormGroup label="State" value={values.mailing_state} onChange={(v) => setData({mailing_state: v})} />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6">
            <FormGroup label="Country" value={values.mailing_country} onChange={(v) => setData({mailing_country: v})} />
          </div>
          <div className="col-12 col-sm-6">
            <FormGroup label="Postal Code" value={values.mailing_postal_code} onChange={(v) => setData({mailing_postal_code: v})} />
          </div>
        </div>
      </fieldset>
    )
  }
}

export default CompanyMailing

